import { useCallback, useRef, useState } from 'react';
import { ScrollView, View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { useFocusEffect } from 'expo-router';
import { Box } from '@/components/ui/primitives';
import AppHeader from '@/components/AppHeader';
import NativeTabFocusGate from '@/components/navigation/NativeTabFocusGate';
import { useLeagueContext } from '@/contexts/LeagueContext';
import WeeklyScores from '@/components/WeeklyScores';

export default function LeagueScoresRoute() {
  const context = useLeagueContext();
  const scrollRef = useRef<ScrollView>(null);
  const viewportRef = useRef<View>(null);
  const scrollOffsetRef = useRef(0);
  const [scrollToUserToken, setScrollToUserToken] = useState(0);

  const {
    id,
    resolvedSeasonId,
    league,
    leagueScoringSystem,
  } = context;

  const headerTitle = league?.name ?? 'League';

  useFocusEffect(
    useCallback(() => {
      setScrollToUserToken((token) => token + 1);
    }, []),
  );

  return (
    <NativeTabFocusGate>
      <Box flex={1} backgroundColor="background">
        <AppHeader title={headerTitle} currentLeagueId={id} allowBack={false} />
        <View ref={viewportRef} style={styles.flex}>
          <ScrollView
            ref={scrollRef}
            style={styles.flex}
            contentContainerStyle={styles.content}
            onScroll={(event) => {
              scrollOffsetRef.current = event.nativeEvent.contentOffset.y;
            }}
            scrollEventThrottle={16}
            showsVerticalScrollIndicator
          >
            <WeeklyScores
              leagueId={id}
              scoringSystem={leagueScoringSystem}
              seasonId={resolvedSeasonId ?? undefined}
              scrollToUserToken={scrollToUserToken}
              verticalScrollOffsetRef={scrollOffsetRef}
              verticalScrollRef={scrollRef}
              verticalViewportRef={viewportRef}
            />
          </ScrollView>
        </View>
      </Box>
    </NativeTabFocusGate>
  );
}

const styles = StyleSheet.create(() => ({
  content: {
    flexGrow: 1,
    paddingBottom: 100,
    paddingHorizontal: 0,
    paddingTop: 0,
  },
  flex: {
    flex: 1,
  },
}));
